<script>
    import AccountNumberInput from "./AccountNumberInput.svelte";

    export let id;
    export let label;
    export let value;
    export let disabled = null;
    export let required = null;


	let maskedValue;
	$:{
		if (value && value.length > 3) {
			maskedValue = "*".repeat(value.length - 3) + value.substring(value.length - 3);
		} else {
			maskedValue = value;
		}
	}

</script>

<AccountNumberInput {required} {disabled} {label} {id} bind:value={maskedValue}></AccountNumberInput>
